export default "__VITE_ASSET__0a001d70__"